import * as React from "react";
const SvgFiRrShovel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shovel_svg__a)">
      <path
        fill="#062147"
        d="m23.707 5.793-5.5-5.5a.999.999 0 1 0-1.414 1.414l2.043 2.043-8.864 8.864-1.191-1.19c-1.211-1.213-3.326-1.213-4.539 0l-1.606 1.605A8.94 8.94 0 0 0 0 19.393V20.5C0 22.43 1.57 24 3.5 24h1.107a8.94 8.94 0 0 0 6.364-2.636l1.606-1.606c.606-.606.94-1.412.94-2.269s-.333-1.664-.94-2.27l-1.191-1.19 8.864-8.865 2.043 2.043a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414m-12.544 10.84a1.21 1.21 0 0 1 0 1.71L9.557 19.95A6.96 6.96 0 0 1 4.607 22H3.5c-.827 0-1.5-.673-1.5-1.5v-1.107c0-1.87.728-3.628 2.05-4.95l1.606-1.606c.236-.236.545-.354.855-.354s.619.118.855.354l1.191 1.191-2.265 2.265a.999.999 0 1 0 1.414 1.414l2.265-2.265z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shovel_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShovel;
